import { render } from "./aboutButtons.vue?vue&type=template&id=deb26e00"
import script from "./aboutButtons.vue?vue&type=script&lang=js"
export * from "./aboutButtons.vue?vue&type=script&lang=js"

import "./aboutButtons.vue?vue&type=style&index=0&id=deb26e00&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__